var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full mt-10" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "w-full" },
      _vm._l(_vm.faqs, function(faq, index) {
        return _c("AccordianItem", {
          key: index,
          attrs: { title: faq.title, content: faq.content }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-full" }, [
      _c(
        "h2",
        {
          staticClass:
            "text-center text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
        },
        [_vm._v(" Frequently asked questions ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }